import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useConsent } from '../../services/ConsentContextProvider';
import '../../css/visualComponent/CookieBanner.css';

export const CookieBanner = () => {
  const { t } = useTranslation('global');
  const { status, isOpen, analytics, marketing, acceptAll, rejectAll, save } = useConsent();
  const [view, setView] = useState('summary');
  const [draft, setDraft] = useState({ analytics: false, marketing: false });

  const visible = status === 'unset' || isOpen;
  if (!visible) return null;

  const openManage = () => {
    setDraft({ analytics, marketing });
    setView('manage');
  };

  return (
    <div className="cookie-banner" role="region" aria-label={t('cookies.banner.ariaLabel')}>
      <div className="cookie-banner-inner">
        <div className="cookie-banner-head">
          <h2 className="cookie-banner-title">{t('cookies.banner.title')}</h2>
          <p className="cookie-banner-body">{t('cookies.banner.body')}</p>
        </div>

        {view === 'manage' && (
          <ul className="cookie-cats">
            <li className="cookie-cat">
              <label>
                <input type="checkbox" checked disabled />
                <span className="cookie-cat-label">{t('cookies.banner.categories.necessary.label')}</span>
              </label>
              <p className="cookie-cat-desc">{t('cookies.banner.categories.necessary.desc')}</p>
            </li>
            <li className="cookie-cat">
              <label>
                <input
                  type="checkbox"
                  aria-label={t('cookies.banner.categories.analytics.label')}
                  checked={draft.analytics}
                  onChange={(e) => setDraft((d) => ({ ...d, analytics: e.target.checked }))}
                />
                <span className="cookie-cat-label">{t('cookies.banner.categories.analytics.label')}</span>
              </label>
              <p className="cookie-cat-desc">{t('cookies.banner.categories.analytics.desc')}</p>
            </li>
            <li className="cookie-cat">
              <label>
                <input
                  type="checkbox"
                  aria-label={t('cookies.banner.categories.marketing.label')}
                  checked={draft.marketing}
                  onChange={(e) => setDraft((d) => ({ ...d, marketing: e.target.checked }))}
                />
                <span className="cookie-cat-label">{t('cookies.banner.categories.marketing.label')}</span>
              </label>
              <p className="cookie-cat-desc">{t('cookies.banner.categories.marketing.desc')}</p>
            </li>
          </ul>
        )}

        <div className="cookie-banner-actions">
          {view === 'summary' ? (
            <>
              <button type="button" className="cookie-btn cookie-btn-ghost" onClick={openManage}>
                {t('cookies.banner.manage')}
              </button>
              <button type="button" className="cookie-btn cookie-btn-ghost" onClick={rejectAll}>
                {t('cookies.banner.rejectAll')}
              </button>
              <button type="button" className="cookie-btn cookie-btn-primary" onClick={acceptAll}>
                {t('cookies.banner.acceptAll')}
              </button>
            </>
          ) : (
            <button type="button" className="cookie-btn cookie-btn-primary" onClick={() => save(draft)}>
              {t('cookies.banner.save')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
